// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

import Scroller from '@newswire/scroller';
import resizer from './ai2html-resizer';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({
    adSection: window.AD_SECTION,
  });
  adLoader.init();
});

// Write your code!

var scenes = document.querySelectorAll('.scene');
var img = document.querySelectorAll('.graphic figure img');

var offset = 0;

var scroller = new Scroller({
  container: document.querySelector('.scroller-container'),
  scenes: scenes,
  offset: offset,
});

scroller.on('scene:enter', function (d) {
  var slideIndex = d.index;
  img[slideIndex].classList.add('is-active');
});

scroller.on('scene:exit', function (d) {
  var slideIndex = d.index;
  var down = d.isScrollingDown;
  if (down == false && slideIndex == 0) {
    img[0].classList.add('is-active');
  } else if (down == false) {
    img[slideIndex].classList.remove('is-active');
  }
});

scroller.init();

// animate sierra map
const desktopWidth = 598,
  mobileWidth = 345;
let isMobile = window.innerWidth <= 630 ? true : false;
const severeLayerNameFormat = '#g-ca-sierra-cbi4-final';
const maxYear = 2021,
  minYear = 2012;
const yearList = Array.from(
  {
    length: maxYear + 1 - minYear,
  },
  (_, i) => i + minYear
);

const createOption = (txt) => {
  const option = document.createElement('option');
  option.textContent = txt;
  option.value = txt;
  return option;
};
const dropdownMenu = document.querySelector('.dropdown select');
dropdownMenu.appendChild(createOption('2012 - 2021'));

yearList.forEach((y, i) => {
  dropdownMenu.appendChild(createOption(y));
});

dropdownMenu.addEventListener('change', (e) => {
  // hide all layers
  const sierraArtboards = document.querySelectorAll(
    '#g-ca-sierra-cbi4-final-box .g-artboard'
  );
  sierraArtboards.forEach((a) => {
    a.classList.add('hide');
  });

  // console.log(e.target.value);
  const selYear = e.target.value;
  if (selYear == '2012 - 2021') {
    sierraArtboards.forEach((a) => {
      a.classList.remove('hide');
    });
  } else {
    document
      .querySelector(`${severeLayerNameFormat}-${selYear}`)
      .classList.remove('hide');
  }
});
